import { Record as record } from 'immutable';

import { resolve } from '../../helpers/LinkMapper';
import Address from './Address';

const defaults = {
    id: null,
    pan: null,
    nickname: null,
    cardToken: null,
    cardType: null,
    holderName: null,
    expiryDate: null,
    isKeyGoCard: null,
    address: new Address(),
    link: null
};

class StoredPaymentCard extends record(defaults) {

    static fromJSON (json = {}) {
        return new StoredPaymentCard({
            id: resolve(json.id).with(Number),
            pan: resolve(json.pan).with(String),
            nickname: resolve(json.nickname).with(String),
            cardToken: resolve(json.cardToken).with(String),
            cardType: resolve(json.cardType).with(String),
            holderName: resolve(json.holderName).with(String),
            expiryDate: resolve(json.expiryDate).with(String),
            isKeyGoCard: resolve(json.isKeyGoCard).with(Boolean),
            address: resolve(json.address).as(Address),
            link: resolve(json.link).with(String),
        });
    }

    getLastDigits () {
        return this.pan.substr(-4);
    }

}


export default StoredPaymentCard;



// WEBPACK FOOTER //
// ./src/records/customer/StoredPaymentCard.js